export const withClientTypeHeader = (url, headers) => {
    if (!url.startsWith(REACT_APP_API_BASE_URL_NEW)) {
        return headers;
    }
    return { ...headers, "X-Client-Type": "web" };
};
